import React from 'react'
import PropTypes from 'prop-types'

import CalendarHelper from "../calendar-helper"
import UI5CalendarHeader from "./header"
import UI5CalendarMonthHeader from "./month-header"
import UI5CalendarMonthDays from "./month-days"

const debug = false
// const debug = "UI5CalendarContent"

export default class UI5CalendarContent extends React.Component {
    static propTypes = {
        initialMonth            : PropTypes.object,                             // Moment object  ----> Moment .... current month

        selectedDays            : PropTypes.arrayOf(PropTypes.shape({
            startDate   : PropTypes.object,                     //Moment
            endDate     : PropTypes.object,                     //Moment
            className   : PropTypes.string
        })),

        disabledDays            : PropTypes.arrayOf(PropTypes.shape({
            startDate   : PropTypes.object,                     //Moment
            endDate     : PropTypes.object,                     //Moment
            className   : PropTypes.string
        })),

        highlightRange          : PropTypes.object,

        headerDateFormat        : PropTypes.string,
        headerDOWFormat         : PropTypes.string,

        minDate                 : PropTypes.object,                             // Moment, adds disabled option for view + no event on click
        maxDate                 : PropTypes.object,

        minNavigationDate       : PropTypes.object,
        maxNavigationDate       : PropTypes.object,

        dndManager              : PropTypes.object,
        calendarDayDnd          : PropTypes.func,                               // special class to override control for drop into calendar days

        navigationArrowsPosition: PropTypes.oneOf(['left-right', 'right']),     // header navigation arrow left on left and right on right side or both on right side

        showTodayButton         : PropTypes.bool,                               // show button beside month title to jump to today on click
        focusOnLastDate         : PropTypes.bool,                               // change month according to last date in selected range on component mount
        sameHeightMonths        : PropTypes.bool,                               // force all months be of the same height (fill days from previous and next months if necessary)

        onHighlightDate         : PropTypes.func,
        onMonthChange           : PropTypes.func,
        onClickMonthSelection   : PropTypes.func,
        onSelect                : PropTypes.func,                               // on date selected -> returns moment
    }

    static defaultProps = {
        navigationArrowsPosition: 'left-right'
    }

    constructor(props) {
        super(props)

        const calendarHelper = new CalendarHelper(this, props)
        this.state = {
            calendarHelper  : calendarHelper,
            currentMonth    : calendarHelper.currentMonth,
        }
    }

    static getDerivedStateFromProps(nextProps, state) {
        state.calendarHelper.setProps(nextProps)
        state.calendarHelper.updateMonth()
        return null
    }

    get calendarHelper() {return this.state.calendarHelper}

    onMonthChanged = () => {
        this.setState({currentMonth: this.state.calendarHelper.currentMonth},
            ()=>{if(this.props.onMonthChange) this.props.onMonthChange(this.state.calendarHelper.currentMonth)})
    }

    render() {
        debug && console.log(debug, "render", this.state.calendarHelper.currentMonthDays)

        return (
            <div className={Classes("calendar-content", this.props.className)}>
                <UI5CalendarHeader calendar                 = {this.state.calendarHelper}
                                   navigationArrowsPosition = {this.props.navigationArrowsPosition}
                                   headerDateFormat         = {this.props.headerDateFormat}
                                   minNavigationDate        = {this.props.minNavigationDate}
                                   maxNavigationDate        = {this.props.maxNavigationDate}
                                   showTodayButton          = {this.props.showTodayButton}
                                   onClickMonth             = {this.props.onClickMonthSelection}/>

                <UI5CalendarMonthHeader headerDOWFormat = {this.props.headerDOWFormat}/>

                <UI5CalendarMonthDays calendar          = {this.state.calendarHelper}
                                      dndManager        = {this.props.dndManager}
                                      calendarDayDnd    = {this.props.calendarDayDnd}
                                      onHighlightDate   = {this.props.onHighlightDate}
                                      onSelect          = {this.props.onSelect}/>
            </div>
        )
    }
}